import React, { Component } from 'react';
import { store, closePreview } from '../components/_App/redux';

class Preview extends Component {
	constructor(props) {
		super(props);
		this.state = {
			src: null,
			isOpen: false
		};
		
		const unsubscribe = store.subscribe(() => {
			this.updateState();
		});
	}

	closePreview() {
		store.dispatch(closePreview());
	}

	prevPreview() {
		console.log('prev');
	}

	nextPreview() {
		console.log('next');
	}
	

	updateState() {
		this.setState(store.getState().preview);
	}

	render() {
		let previewClass = [ 'image-preview' ];
		if (this.state.isOpen) {
			previewClass.push('is-open');
		}

		return (

			<div className={previewClass.join(' ')}>
			{ this.state.isOpen && this.state.src !== null ? (
				<div className="image-preview-modal">
					<div className="image-preview-modal__overlay"></div>
					<img className="image-preview-modal__image" alt="Preview" src={ this.state.src }></img>
					<div className="image-preview-modal__top cursor-close" onClick={ () => { this.closePreview() }}>
						{/* <div className="image-preview-modal__top-close cursor-close" onClick={ () => { this.closePreview() }}></div>
						<div className="image-preview-modal__top-prev cursor-prev" onClick={ () => { this.prevPreview() }}></div>
						<div className="image-preview-modal__top-next cursor-next" onClick={ () => { this.nextPreview() }}></div> */}
					</div>
				</div>
			) : null }
		</div>
		);
	}
}

export default Preview;
